import React, { useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'

import { ParentCategory } from '@library/menu-page'
import type { CollectionUUID, CollectionSlug } from '@library/menu-service'
import { queueTrackingEvent } from '@library/tracking-integration'

import { useSelectCollection } from 'hooks/menu-collections'
import { useParentCategories } from 'hooks/menu-parentcategories/useParentCategories'
import type { SelectCollectionEvent } from 'routes/Menu/MenuExperience/MenuPage/types'
import { useBasketDelivery } from 'routes/Menu/domains/basket/internal/delivery'

export const BrowseScreen = () => {
  const parentCategories = useParentCategories()
  const selectCollection = useSelectCollection()
  const delivery = useBasketDelivery()

  useEffect(() => {
    if (parentCategories.length === 0) {
      return
    }

    datadogRum?.addAction('view_browse_screen', {
      deliveryDate: delivery.date,
      parentCategoriesCount: parentCategories.length,
    })
  }, [delivery.date, parentCategories.length])

  const onCategoryClick = (categoryId: CollectionUUID, categorySlug: CollectionSlug) => {
    queueTrackingEvent<SelectCollectionEvent>({
      action: 'select_collection',
      properties: {
        collection_id: categoryId,
        collection_slug: categorySlug,
        navigation_method: 'browse',
      },
    })
    selectCollection(categoryId)
  }

  return (
    <Box display={Display.Flex} paddingH={[3, 3, 0]} flexDirection={FlexDirection.Column} gap={10}>
      {parentCategories.map(
        ({ id, slug, categories, description, isLinkable, type, name, recipeCount }) => (
          <div key={id}>
            <ParentCategory
              id={id}
              slug={slug}
              categories={categories}
              description={description}
              isLinkable={isLinkable}
              type={type}
              name={name ?? ''}
              recipeCount={recipeCount}
              onCategoryClick={onCategoryClick}
            />
          </div>
        ),
      )}
    </Box>
  )
}
